import React from 'react';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import PropTypes from 'prop-types';
import Stack from '@mui/material/Stack';
import Tooltip from '@mui/material/Tooltip';
import ONBOARDING_TOOLTIP_CLASS_NAME from '../../theme/constants/tooltip';

const OnboardingDaysButton = ({
  label,
  id,
  variant,
  onClick,
  className,
  showButtonSubtitle,
  buttonProps,
  labelVariant,
  subtitleVariant,
  detail,
  icon,
  tooltipInfo,
  size,
}) => (
  <Button
    variant={variant}
    color="primary"
    id={id}
    onClick={onClick}
    className={className}
    size={size}
    {...buttonProps}
  >
    <Stack direction={(icon || detail) ? 'row' : 'column'} alignItems="center" width="100%" spacing={1}>
      <Box flex={1} display="flex" flexDirection="column" alignItems="center">
        <Typography variant={labelVariant} fontWeight={700}>
          {label}
        </Typography>
        {showButtonSubtitle && (
        <Typography variant={subtitleVariant} display="block" className="subtitle">
          días
        </Typography>
        )}
      </Box>
      {detail && (
        <>
          <Box flex={1} display="flex" flexDirection="column" alignItems="flex-start">
            <Typography
              variant="small_2"
              fontWeight="bold"
              color="text.highlight"
              sx={{ textAlign: 'left', width: '100%' }}
            >
              {detail}
            </Typography>
          </Box>
          {tooltipInfo && icon && (
            <Tooltip
              title={(
                <Typography variant="body2" textAlign="left" sx={{ maxWidth: 130 }}>
                  {tooltipInfo}
                </Typography>
              )}
              placement="bottom-start"
              classes={{ tooltip: ONBOARDING_TOOLTIP_CLASS_NAME }}
              componentsProps={{
                tooltip: {
                  sx: { marginTop: '-5px!important' },
                },
              }}
            >
              <Box>{icon}</Box>
            </Tooltip>
          )}
        </>
      )}
    </Stack>
  </Button>
);

OnboardingDaysButton.propTypes = {
  label: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
  className: PropTypes.string,
  variant: PropTypes.string,
  onClick: PropTypes.func.isRequired,
  showButtonSubtitle: PropTypes.bool,
  buttonProps: PropTypes.shape({}),
  labelVariant: PropTypes.string,
  subtitleVariant: PropTypes.string,
  detail: PropTypes.node,
  icon: PropTypes.node,
  tooltipInfo: PropTypes.string,
  size: PropTypes.string,
};

OnboardingDaysButton.defaultProps = {
  className: '',
  variant: 'onboardingOutlined',
  showButtonSubtitle: false,
  buttonProps: {},
  labelVariant: 'small_2',
  subtitleVariant: 'small_1',
  detail: null,
  icon: null,
  tooltipInfo: null,
  size: '',
};

export default OnboardingDaysButton;
